<template>
    <div class="app">
        <div class="searchBox">
            <div class="address">
                <img src="../../assets/images/address.png" alt="">
                <span>靖江</span>
                <img src="../../assets/images/arrowBottom.png" alt="">
            </div>            
            <div class="search">
                <img src="../../assets/images/searchIcon.png" alt="">
                <input type="text" placeholder="搜索商铺" @click="searched" v-model.trim="keywords">
            </div>
        </div>
        <div class="content">
            <div class="blank"></div>
            <div class="noCard" v-if="haveCard">
                <img src="../../assets/images/search.png" alt="">
                <span>暂无任何商家信息</span>
            </div>
            <div class="haveCard" v-if="!haveCard">
                <!-- <div class="classify">
                        <select>
                            <option value="全部分类">全部分类</option>
                        </select>
                        <select>
                            <option value="全部分类">全城</option>
                        </select>
                </div> -->
                <div v-if="!isSearch" class="shopList">
                    <ul>
                        <!-- <li v-for="(value,index) in cardArry" :key="index" @click="goActivityDetail(index)">
                            <div class="shop">
                                <img src="../../assets/images/ostart.png" alt="">
                                <span>云水山房</span>
                                <span>会员优品体验全城最低39元起</span>
                                <img src="../../assets/images/address.png" alt="">
                                <span>中洲路滨江花园</span>
                                <span>市中心&lt;500m</span>
                            </div>
                        </li> -->
                        <li>
                            <div class="shop">
                                <img src="../../assets/images/ostart.png" alt="">
                                <span>云水山房</span>
                                <span>会员优品体验全城最低39元起</span>
                                <img src="../../assets/images/address.png" alt="">
                                <span>中洲路滨江花园</span>
                                <span>市中心&lt;500m</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="isSearch" class="shopList">
                    <ul>
                        <li v-for="(value,index) in searchResult(keywords)" :key="index" @click="goActivityDetail(index)">
                            <div class="shop">
                                <img src="../../assets/images/ostart.png" alt="">
                                <span>{{value.name}}</span>
                                <span>{{value.description}}</span>
                                <img src="../../assets/images/address.png" alt="">
                                <span>中洲路滨江花园</span>
                                <span>市中心&lt;500m</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from "../footerTo/bottom";
import { DatetimePicker, Popup, Toast, Indicator, Radio } from "mint-ui";
import axios from "axios";
import store from "@/vuex/store";
import { mapState } from "vuex"; 
import global from "../../../static/js/global";
import config from "../../../static/js/config";
import { clearTimeout } from 'timers';
import { constants } from 'fs';

export default {
  data() {
    return { 
        isSearch:false,
        isSend:false, 
        haveCard:false,
        haveMsg:false, 
        cardArry:[],              // 会员卡列表信息 
        keywords:'',    //搜索关键字
        activityList:[],
        searchArry:[],
    };
  },
  computed: {},
  components: {
      "bottom":bottom,
  }, 
  methods: {
      searchResult(keywords){
          return this.searchArry = this.activity.filter(item => {
              if(item.cName.includes(keywords)){
                  return item;
              }
          })
      },
      //
      searched(){
          this.isSearch = true;
      },
      // 跳转到活动详情页面
      goActivityDetail(index)
      {
          this.$router.push({ 
              name:"activityDetail",
              query:
              {
                  index:index
              }
              });
      },
      checkHttpReturn(id)
      {
          if(httpSendQue[id]==0)
          {
              var  self=this;
              setTimeout(() => {
                      if (self && !self._isDestroyed)
                          self.checkHttpTimeOut();
                  }, newConfigTime);

          }
          else
          {
              delete httpSendQue[id];
          }
      },
      checkHttpTimeOut()
      {
          if(httpSendQue[id]==0)
          {
              //  隐藏加载中
                this.Toast.close()
                Toast({
                      message: '网络不给力',
                      position: 'middle',
                      duration: 3000
                    })
                

          }
          else
          {
              //删除数组中的id
              delete httpSendQue[id];

          }
      },
    //   获取店家活动列表
      getActivityList(){
          var sid = localStorage.getItem("sid");
        //   var beginIdx = 0;
        //   var maxRows = 3;
          axios.get(listActivities + "&sid=" + sid + "&uid=" + uid + "&sign=" + sign + "&mode=" + mode + "&beginIdx=" + 0 + "&maxRows=" + 3)
          .then(res => {
              console.log("aaaaaaa",res);
          })
          .catch(error=>{
                // httpSendQue[id] = 1;   
                this.Toast.close()
                Toast({
                    message: '网络不给力',
                    position: 'middle',
                    duration:2000
                })
           })
      },
    //   getActivityImg(){
    //       var sid = localStorage.getItem("sid");
    //       axios.get(activePicture + "&sid=" + sid + "&picName=" + picName + "&sign=" + sign + "&mode=" + mode)
    //       .then(res => {
    //       })
    //   },

  },
  mounted()
  {
    //   this.getMemberCardList();
      this.getActivityList();
  },
            
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
.searchBox{
  height: 2.11rem;
  width: 100%;
  /* background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%); */
  position: fixed;
  background-color: #fff;
  z-index: 1;
}
.address{
    width: 0.79rem;
    height: 0.79rem;
    position: relative;
    top: 0.5rem;
    left: 0.42rem;
}
.address :nth-child(1){
    width: 0.53rem;
    height: 0.53rem;
    position: absolute;
    top: -0.08rem;
    left: -0.2rem;
}
.address :nth-child(2){
    width: 100%;
    font-size: 0.32rem;
    color: rgba(0, 0, 0, 0.9);
    position: absolute;
    top: 0;
    left: 0.45rem;
}
.address :nth-child(3){
    width: 0.33rem;
    height: 0.33rem;
    position: absolute;
    top: 0.08rem;
    left: 1.24rem;
}
.search{
    width: 7.42rem;
    height: 1.26rem;
    line-height: 1.26rem;
    border-radius: 0.05rem;
    border: 0.03rem solid rgba(255, 255, 255, 1);
    box-shadow: 0 0.05rem 0.05rem 0 rgba(0, 0, 0, 0.24);
    background-color: rgba(250, 250, 250, 1);
    margin-left: 1.63rem;
    position: relative;
    top: -0.65rem;
    left: 0.5rem;
}
.search :nth-child(1){
    width: 0.45rem;
    height: 0.45rem;
    position: absolute;
    top: 0.39rem;
    left: 0.61rem;
}
.search :nth-child(2){
    width: 5.26rem;
    height: 0.79rem;
    border: none;
    position: absolute;
    top: 0.24rem;
    left: 1.26rem;
}
.redPoint{
    display: block;
    border-radius: 50%;
    width: 0.26rem;
    height: 0.26rem;
    background-color: rgba(246, 34, 65, 1);
    position: relative;
    top: -2.45rem;
    left: 9.35rem;
}
.blank {
  height: 2.11rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  font-size: 0.42rem;
  /* background-color: rgba(0, 0, 0, 0.1); */
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
.noCard{
    width: 100%;
    height: 84%;
    text-align: center;
    position: relative;
}
.noCard :nth-child(1){
    width: 2.42rem;
    height: 2.16rem;
    position: absolute;
    top: 1.67rem;
    left: 3.75rem;
}
.noCard :nth-child(2){
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 4.68rem;
    left: 3.5rem;
}
.haveCard{
    background-color: rgba(241, 241, 241, 1);
    height: 100%;
}
.classify{
    height: 0.8rem;
    width: 100%;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
    background-color: #fff;
}
select{
    border: none;
    background-color: #fff;
}
.shop{
    background-color: #fff;
    width: 100%;
    height: 2.79rem;
    margin-bottom: 0.1rem;
    border: 0.03rem solid rgba(255, 255, 255, 0);
    position: relative;
}
.shop :nth-child(1){
    width: 2.11rem;
    height: 2.11rem;
    position: absolute;
    top: 0.32rem;
    left: 0.32rem;
}
.shop :nth-child(2){
    position: absolute;
    top: 0.21rem;
    left: 2.95rem;
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.9);
}
.shop :nth-child(3){
    position: absolute;
    top: 0.87rem;
    left: 2.95rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.shop :nth-child(4){
    width: 0.53rem;
    height: 0.53rem;
    position: absolute;
    top: 1.71rem;
    left: 2.95rem;
}
.shop :nth-child(5){
    position: absolute;
    top: 1.71rem;
    left: 3.53rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.shop :nth-child(6){
    position: absolute;
    top: 1.71rem;
    left: 7.29rem;
    font-size: 0.32rem;
    color: rgba(0, 0, 0, 0.5);
} 
</style>



// WEBPACK FOOTER //
// src/components/homepage/find.vue